import { APIClient } from "api/api_helper";
import { AdverseEventMedications_API } from "api/url_helper";
import { GetUserData, CurrentUser } from "common/service/CommonService";

const api = new APIClient();

export const adverseEventMedicationsApiService = {
  insertData: (data: any) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      ...data,
      createdby: user?.userid,
    };
    return api.create(AdverseEventMedications_API.AdverseEventMedications_API + "Insert", payload);
  },

  updateData: (data: any) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      ...data,
      updatedby: user?.userid,
    };
    return api.create(AdverseEventMedications_API.AdverseEventMedications_API + "Update", payload);
  },

  getSelectById: (data: any) => {
    return api.create(AdverseEventMedications_API.AdverseEventMedications_API + "Select", data);
  },

  deleteData: (data: any) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      ...data,
      updatedby: user?.userid,
    };
    return api.create(AdverseEventMedications_API.AdverseEventMedications_API + "Delete", payload);
  },
};
